import { Commit } from 'vuex';
import { SuiviFinancierState } from './state';

export enum SuiviFinancier {
    GET_SUIVI_FINANCIER = 'GET_SUIVI_FINANCIER',
    GET_SUIVI_FINANCIER_XLS = 'GET_SUIVI_FINANCIER_XLS',
    GET_FACTURE_PDF = 'GET_FACTURE_PDF'
}

export interface SuiviFinancierActionTypes {
    commit: Commit,
    state: SuiviFinancierState,
    getters: any
}
